module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }